import * as React from 'react';
import {connect} from 'react-redux';
import {IFamilyMember} from '@app-types/websocket/family.types';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { IDayData } from '../calendar.types';
import { MonthviewStyle } from '../monthView/monthview.style';
import Day from '../monthView/Day';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { ILocalEvent } from '@app-types/websocket/event.types';
import { addDays } from '@helpers/DateHelper';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { holidays as allHolidays } from '../holidays/holidays';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof MonthviewStyle> {
  userId:number;
  localization: "se"|"en";
  focusDay:Date;
  family:IFamilyMember[];
  scheduleOne:ISchedule|undefined;
  scheduleTwo:ISchedule|undefined;
  scheduleThree:ISchedule|undefined;
  importedEvents:ILocalEvent[];
  style?:React.CSSProperties;
  highlight:IDateRange[];
  idPrefix?:string;
  isEditing:boolean;
  setFocusDate: (year:number,month:number,date:number) => void;
  holidays:{ [key:string]:{title:string, type:"HOLIDAY"|"SPECIAL_DAY"}; };
}

interface IState {
  someValue: number;
}

class OriginalWeek extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      someValue: 1,
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    return;
  }

  public componentDidMount() {
    return;
  }

  public render() {

    const schoolAge:number = schoolAgeFromFamily(this.props.family);

    const {classes, scheduleOne, scheduleTwo, scheduleThree, family,  focusDay, localization } = this.props;
    let spinDate:Date = new Date(focusDay.getFullYear(), focusDay.getMonth(), focusDay.getDate(), 0,0,0,1);
    
    while ((localization === "en" && spinDate.getDay() !== 0) || (localization === "se" && spinDate.getDay() !== 1)) {
      spinDate = addDays(spinDate, -1);
    }
    let startTime = spinDate.getTime();
    spinDate.setHours(23);
    spinDate.setMinutes(59);
    spinDate.setSeconds(59);
    spinDate.setMilliseconds(999);
    let endTime = 0;
    const days: JSX.Element[] = [];
    while (days.length < 7) {

        endTime = spinDate.getTime();
        let highlight= false;

        const dayData:IDayData = {
          year: spinDate.getFullYear(),
          month: spinDate.getMonth(),
          date: spinDate.getDate(),
          startTime,
          endTime,
        }

        const midDay = (startTime+endTime)/2;
        for (const range of this.props.highlight) {
          if (midDay > range.start && midDay < range.end) {
            highlight = true;
            break;
          }
        }

        startTime = endTime;
        spinDate = addDays(spinDate, 1);
        endTime = spinDate.getTime();
    
        

        days.push(<Day 
          userId={this.props.userId}
          importedEvents={this.props.importedEvents}
          isEditing={this.props.isEditing}
          key={days.length} 
          localization={this.props.localization} 
          size={"large"} 
          family={family}
          hideEvents={true}
          events={[]}
          schoolAge={schoolAge}
          externalEvents={[]}
          data={dayData}
          scheduleOne={scheduleOne}
          scheduleTwo={scheduleTwo}
          scheduleThree={scheduleThree}
          isSelectedForEdit={false} 
          isFocus={false}
          isHighlight={highlight}
          idPrefix='preview'
          popMenu={() => {return}}
          holidays={this.props.holidays}
          hasDismissedLongPress={true}
          setFocusDate={(year:number, month:number, date:number) => this.props.setFocusDate(year,month,date)} />);
    }

    return (
      <div className={classes.week} style={this.props.style}>
          {days}
      </div>
    );
  }

}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const country = (state.user.calendarSettings && state.user.calendarSettings.holidaysCountry )
    ?state.user.calendarSettings.holidaysCountry
    :undefined;
  const holidays = allHolidays.getHolidays(country);
  return {
    userId,
    family: state.family.family,
    holidays,
  };
}

export default connect(mapStateToProps)(withStyles(MonthviewStyle)(OriginalWeek));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/OriginalWeek.tsx